var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-progress-bar"},[_c('div',{staticClass:"app-progress-bar__progress",style:(("width: " + _vm.progress + "%;"))})])}
var staticRenderFns = []

export { render, staticRenderFns }